import React, { useEffect, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, brl, productImage } from "../lib/api";

const CATS = [
  { key: "", label: "Todos" },
  { key: "imas", label: "Imãs" },
  { key: "botons", label: "Botons" },
  { key: "chaveiros", label: "Chaveiros" },
  { key: "fotos", label: "Fotos" },
  { key: "adesivos", label: "Adesivos" },
  { key: "servicos", label: "Serviços" },
];

export default function Catalog() {
  const [params, setParams] = useSearchParams();
  const cat = params.get("c") || "";
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const url = cat ? `/products?category=${cat}` : "/products";
    api.get(url).then(({ data }) => setProducts(data)).catch(() => {});
  }, [cat]);

  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-8 py-14" data-testid="catalog-root">
      <div className="text-center max-w-2xl mx-auto">
        <div className="eyebrow">Catálogo</div>
        <h1 className="mt-3 font-display text-4xl md:text-5xl text-[#0D1B2A]">
          Escolha sua <em className="font-script text-[#D4AF37] not-italic">lembrança perfeita</em>
        </h1>
      </div>

      <div className="mt-10 flex flex-wrap justify-center gap-2" data-testid="catalog-filters">
        {CATS.map((c) => (
          <button
            key={c.key || "all"}
            data-testid={`filter-${c.key || "all"}`}
            onClick={() => setParams(c.key ? { c: c.key } : {})}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
              cat === c.key
                ? "bg-[#0D1B2A] text-white"
                : "bg-white text-[#0D1B2A] border border-[#0D1B2A]/10 hover:border-[#D4AF37]"
            }`}
          >
            {c.label}
          </button>
        ))}
      </div>

      <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
        {products.map((p) => (
          <Link
            key={p.id}
            to={`/produto/${p.slug}`}
            data-testid={`product-card-${p.slug}`}
            className="group bg-white rounded-2xl overflow-hidden border border-[#0D1B2A]/5 lift"
          >
            <div className="aspect-[4/5] overflow-hidden bg-[#F7F2E7] relative">
              <img src={productImage(p)} alt={p.name} className="product-img w-full h-full object-cover" />
              {p.highlight && (
                <span className="absolute top-3 left-3 bg-[#D4AF37] text-[#0D1B2A] text-[10px] font-bold uppercase tracking-widest px-2.5 py-1 rounded-full">
                  {p.highlight}
                </span>
              )}
            </div>
            <div className="p-4">
              <div className="font-display text-[17px] text-[#0D1B2A] leading-tight">{p.name}</div>
              <div className="mt-1 flex items-center justify-between">
                <span className="text-xs text-[#6B7280] uppercase tracking-wider">{p.category}</span>
                <span className="font-display text-lg text-[#0D1B2A]">{brl(p.price)}</span>
              </div>
            </div>
          </Link>
        ))}
        {products.length === 0 && (
          <div className="col-span-full text-center py-16 text-[#6B7280]">Nenhum produto encontrado.</div>
        )}
      </div>
    </div>
  );
}
